import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaTriangleExclamation } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { openChat } from "../../redux/action/member/memberAction";
import { useLocation } from "react-router-dom";

const FreezeOnlyGameBoxModal = ({ children, className }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`profile.${key}`);
  const i18n_gamebox = (key) => t(`gamebox.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_backend = (key) => t(`backend_response.${key}`);

  const location = useLocation();

  const isSocketMessage = useSelector((state) => state.isSocketMessage);
  const { message, show, show_game_box_modal } = isSocketMessage || {};

  const isGameBox = useMemo(() => {
    return location.pathname.includes("gamebox");
  }, [location.pathname]);

  const memberData = useSelector((state) => state.isMemberInfo);
  const dispatch = useDispatch();

  const textColor = useColorModeValue("dark.100", "light.100");

  const { status } = memberData || {};

  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  useEffect(() => {
    if (show_game_box_modal) {
      setOpenModal(true);
    }
  }, [show_game_box_modal]);

  useEffect(() => {
    if (message) {
      setModalMessage(message);
    }
  }, [message]);

  return isGameBox && openModal ? (
    <>
      <Alert
        {...className}
        position={"absolute"}
        bg={"rgba(0,0,0,0.3)"}
        top="0"
        left="0"
        w="100%"
        h="100%"
        zIndex={999}
        status="info"
        variant="subtle"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
        <AlertIcon boxSize="40px" mr={0} />
        <AlertTitle color={textColor} mt={4} mb={1} fontSize="lg">
          {i18n_common("notice_you")}
        </AlertTitle>
        <AlertDescription fontSize="xl" color={textColor} maxWidth="sm">
          {i18n_backend(modalMessage)}
        </AlertDescription>
      </Alert>
    </>
  ) : null;
};

export default FreezeOnlyGameBoxModal;
